var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Layout', [_c('div', {
    staticClass: "grid-toolbar"
  }), _c('Table', {
    ref: "grid",
    attrs: {
      "border": "",
      "columns": _vm.columns,
      "data": _vm.data,
      "loading": _vm.pageLoading
    },
    on: {
      "on-sort-change": _vm.onSortChange,
      "on-row-click": _vm.onRowClick
    }
  }), _c('div', {
    staticClass: "grid-toolbar"
  }, [_c('Page', {
    attrs: {
      "current": _vm.currentPage,
      "total": _vm.total,
      "page-size": _vm.pageSize,
      "show-total": ""
    },
    on: {
      "on-change": _vm.onCurrentPageChange
    }
  }), _c('RadioGroup', {
    staticClass: "page-selector",
    attrs: {
      "type": "button"
    },
    model: {
      value: _vm.pageSize,
      callback: function callback($$v) {
        _vm.pageSize = $$v;
      },
      expression: "pageSize"
    }
  }, _vm._l([10, 25, 50, 100], function (num) {
    return _c('Radio', {
      key: num,
      attrs: {
        "label": num
      }
    }, [_vm._v(_vm._s(num))]);
  }), 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };